import React from 'react';
import { Link } from 'react-router-dom';
import './404page.css';

// Sidebar components
import Sidebar from '../../myDashboard/Sidebar';
import CloseSidebar from '../../myDashboard/CloseSidebar';

function NotFoundPage({
  isSidebarOpen,
  toggleSidebar,
  heading1,
  heading2,
  paragraph,
  image,
  buttonText,
  buttonLink
}) {
  return (
    <div className="notfound-container">
      {isSidebarOpen ? <Sidebar /> : <CloseSidebar />}
      <div className="notfound-content">
        <img src={image} alt="404 Not Found" className="notfound-image" />
        <div className="notfound-text">
          <div className="notfound-title">{heading1}</div>
          <div className="notfound-subtitle">{heading2}</div>
          <div className="notfound-description">{paragraph}</div>
        </div>
        <Link to={buttonLink} className="notfound-home-link">
          {buttonText}
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
